"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForcedPlayerSettingsContext = exports.DefaultPlayerSettingsContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var DefaultPlayerSettingsContext = exports.DefaultPlayerSettingsContext = /*#__PURE__*/_react["default"].createContext({});
var ForcedPlayerSettingsContext = exports.ForcedPlayerSettingsContext = /*#__PURE__*/_react["default"].createContext({});